import { ConfirmModal } from '@highimpact/dashboard-ui';
import Typography from '@mui/material/Typography';
import { deleteWidgetByElementId } from '../../../state/asyncThunks';
import { setDeleteWidgetConfirmation } from '../../../state/dashboard/slice';
import 'react-pure-modal/dist/react-pure-modal.min.css';

import { useDashboardLibraryDispatch, useDashboardLibrarySelector } from '../../../runtime/DashboardLibraryProvider';
// Component props.
interface DeleteWidgetConfirmationProps {
  dashboardElementId: number;
  gridType: 'grids' | 'reports';
  widgetName: string;
}

function DeleteWidgetConfirmation({
  dashboardElementId,
  gridType,
  widgetName,
}: DeleteWidgetConfirmationProps) {
  const dispatch = useDashboardLibraryDispatch();
  const isModalOpen = useDashboardLibrarySelector(
    (state) =>
      state.dashboard.deleteConfirmationModalIsOpen.state === 'open'
  );

  const closeModal = () => {
    dispatch(setDeleteWidgetConfirmation({ state: 'closed' }));
  };

  const handleConfirm = async () => {
    await dispatch(deleteWidgetByElementId({ dashboardElementId, gridType }));
    closeModal();
  };

  return (
    <div className="confirmation">
      <ConfirmModal
        onCancel={closeModal}
        onConfirm={handleConfirm}
        open={isModalOpen}
      >
        <p>
          Voulez vous supprimer l'élément graphique{' '}
          <Typography component="span" fontWeight="bold">{widgetName}</Typography> ?
        </p>
      </ConfirmModal>
    </div>
  );
}

export default DeleteWidgetConfirmation;
